import React from "react";
import CustomLink from "@/bit/components/components.custom-link";
import Text from "@/bit/components/components.text";

const SkipLink = () => {
  const clickHandler = () => {
    const element = document.querySelector("header");
    if (element) {
      var firstFocusableElement = element.querySelector(
        "input, select, textarea, button, object, a, area[href], [tabindex]"
      );
      firstFocusableElement?.focus();
    }
  };

  return (
    <div className="footer-skip">
      <CustomLink
        onClick={clickHandler}
        title="Volver al inicio"
        taggingInfo={{
          componentName: "footer",
          componentContent: "volver al inicio",
          componentVariation: "screen-reader",
        }}
      >
        <Text
          text="Volver al inicio"
          align="center"
          color="blue_a_1"
          decoration="underline"
        />
      </CustomLink>
      <style jsx>{`.footer-skip :global(button) {
  position: absolute;
  z-index: -2;
  width: 1px;
  height: 1px;
  overflow: hidden;
  top: auto;
  left: -999px;
  background-color: white;
}
.footer-skip :global(button:focus) {
  width: 100%;
  height: 80px;
  top: 0;
  left: 0;
  position: relative;
  z-index: 100;
  padding: 2rem;
  border: 1px dashed #055eac;
  outline:none;
}`}</style>   
    </div>
  );
};
export default SkipLink;
